import { 
  collection, 
  query, 
  where, 
  getDocs, 
  doc, 
  updateDoc,
  getDoc 
} from "firebase/firestore";
import { db } from "../lib/firebase";
import { Chef, MenuItem, Kitchen } from "../types/index";
import { getMenuByKitchenId } from "./kitchen.service"; 

const mapChef = (doc: any): Chef => ({ id: doc.id, ...doc.data() } as Chef);

export const getPendingChefs = async (): Promise<Chef[]> => {
  const usersRef = collection(db, "users");
  const q = query(usersRef, where("roles", "array-contains", "chef"), where("approved", "!=", true));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(mapChef);
};

export const getApprovedChefs = async (): Promise<Chef[]> => {
  const usersRef = collection(db, "users");
  const q = query(usersRef, where("roles", "array-contains", "chef"), where("approved", "==", true));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(mapChef);
};

export const approveChef = async (chefId: string): Promise<void> => {
  const chefRef = doc(db, "users", chefId);
  await updateDoc(chefRef, { approved: true });
};

// FIX: Explicit export for Profile
export const getChefProfile = async (chefId: string): Promise<Chef | null> => {
  const chefRef = doc(db, "users", chefId);
  const snap = await getDoc(chefRef);
  if (snap.exists()) {
      return { id: snap.id, ...snap.data() } as unknown as Chef;
  }
  return null;
};

// FIX: Explicit export, returning MenuItem[] (Array) instead of Menu object
export const getChefMenu = async (chefId: string): Promise<MenuItem[]> => {
  const kitchensRef = collection(db, "kitchens");
  const q = query(kitchensRef, where("chefUids", "array-contains", chefId));
  const kitchenSnap = await getDocs(q);

  if (kitchenSnap.empty) return [];

  const aggregatedItems: MenuItem[] = [];

  await Promise.all(kitchenSnap.docs.map(async (kDoc) => {
    const kitchenData = kDoc.data() as Kitchen;
    const kitchenId = kDoc.id;
    const kitchenName = kitchenData.kitchen_name || kitchenData.name || "Kitchen";

    try {
        const menu = await getMenuByKitchenId(kitchenId);
        if (menu && menu.menuItems) {
            Object.entries(menu.menuItems).forEach(([itemId, itemData]) => {
                if (itemData.isAvailable !== false && (itemData as any).available !== false) {
                    aggregatedItems.push({
                        ...itemData,
                        id: itemId,
                        kitchenId: kitchenId, 
                        kitchenName: kitchenName 
                    });
                }
            });
        }
    } catch (err) {
        console.error(`Failed to load menu for kitchen ${kitchenId}`, err);
    }
  }));

  return aggregatedItems;
};